<template>
  <div>
    <navigation-button to="/trends" :arrow-left="true" :subtle="true" @click="checkForResult">Terug naar keuzepagina trends</navigation-button>
    <h1 class="c-heading-1">{{ currentTopic.title }}</h1>
    <div v-if="step === 1">
      <div class="c-details-introduction">
        <img class="c-image c-image--right" v-if="currentTopic.image" :src="'/images/' + currentTopic.image" :alt="currentTopic.title">
        <p v-html="currentTopic.description"></p>
        <h2 class="c-heading-2">Voorbeeld</h2>
        <p v-html="currentTopic.example"></p>
      </div>
      <div v-if="!noOpinion">
        <answer-scale question="Hoe groot is de impact van deze trend op je bedrijfsvoering binnen 5 jaar?" :amount="5" v-model="impact"/>
        <answer-scale question="Hoe groot is de kans dat deze trend doorbreekt binnen je sector?" :amount="5" v-model="chance"/>
        <input-group :label="highOrLow">
          <textarea :id="uniqueId" v-model="impactComment" slot-scope="{ uniqueId }"></textarea>
        </input-group>

      </div>
      <p>
        <label>
          <input type="checkbox" v-model="noOpinion"> Ik heb geen mening over deze trend en wens die niet te behouden.
        </label>
      </p>
    </div>
    <div v-if="step === 2 && noOpinion === false">
      <ol>
        <li v-for="(question, key) in questions" :key="key">
          <answer-scale :question="question" :amount="7" @input="updateAnswer(key, $event)" :value="answers[key]" label-left="Helemaal oneens" label-right="Helemaal eens"/>
        </li>
      </ol>
    </div>
    <div v-if="step === 3 && noOpinion === false">
      <advice-view
        class="c-details-advice"
        :status="scores.readyForTopic"
        :sizeCategory="scores.sizeCategory"
        :topic="currentTopic"
      />
      <p>Dit is je voorlopig resultaat. We moedigen je  sterk aan om de andere trends verder te ontdekken zodat je je volledige resultaten kan bekijken aan het eind van de rit. Indien je dan verdere stappen wenst te zetten met de hulp van de FutureForward-coaches, hebben zij ook een volledige uitkomst van de scan waarmee zij jou kunnen begeleiden.</p>
    </div>
    <div class="c-toolbar">
      <div class="c-toolbar__right">
        <navigation-button @click="goToStep(2)" v-if="step === 1 && noOpinion === false" :disabled="!step1iscompleted">Volgende</navigation-button>
        <navigation-button @click="goToOverviewAndSave" v-if="step === 1 && noOpinion === true">Terug naar keuzepagina trends</navigation-button>
        <navigation-button @click="goToStep(3)" v-if="step === 2" :disabled="!step2iscompleted">Voorlopig resultaat</navigation-button>
        <navigation-button to="/trends" v-if="step === 3">Volgende trend</navigation-button>
      </div>
    </div>
  </div>
</template>

<script>
import AdviceView from '../components/AdviceView.vue'
import AnswerScale from '../components/AnswerScale.vue'
import NavigationButton from '../components/NavigationButton.vue'
import InputGroup from '../components/InputGroup.vue'
export default {
  components: {
    AdviceView,
    AnswerScale,
    NavigationButton,
    InputGroup
  },
  data () {
    return {
      step: 1
    }
  },
  computed: {
    currentTopic () {
      return this.$store.state.topics[this.$route.params.id]
    },
    highOrLow () {
      if(this.scores.sizeCategory<3)
        return "Verwoord in een paar zinnen waarom je denkt dat de impact op je bedrijfsvoering laag is."
      else if(this.scores.sizeCategory>3)
        return "Verwoord in een paar zinnen waarom je denkt dat de impact op je bedrijfsvoering hoog is."
      else
        return "Verwoord in een paar zinnen waarom je denkt dat de impact op je bedrijfsvoering matig is."
    },
    impactComment: {
      get () {
        return this.$store.state.answers[this.$route.params.id].impactComment || null
      },
      set (value) {
        this.$store.commit('updateImpactComment', {
          topic: this.$route.params.id,
          value: value
        })
      }
    },
    impact: {
      get () {
        return this.$store.state.answers[this.$route.params.id].impact || null
      },
      set (value) {
        this.$store.commit('updateImpact', {
          topic: this.$route.params.id,
          value: parseInt(value)
        })
      }
    },
    chance: {
      get () {
        return this.$store.state.answers[this.$route.params.id].chance || null
      },
      set (value) {
        this.$store.commit('updateChance', {
          topic: this.$route.params.id,
          value: parseInt(value)
        })
      }
    },
    noOpinion: {
      get () {
        return (
          this.$store.state.answers[this.$route.params.id].noOpinion || false
        )
      },
      set (value) {
        this.$store.commit('updateNoOpinion', {
          topic: this.$route.params.id,
          value: value
        })
      }
    },
    answers () {
      return this.$store.state.answers[this.$route.params.id].questions
    },
    questions () {
      if (this.noOpinion === false) {
        const questions = this.currentTopic.questions
        const sizeCategory = this.$store.getters.scores[this.$route.params.id]
          .sizeCategory
        // If category is 0, show no questions
        if (sizeCategory === 0) {
          return {}
          // If category is 1, show question 1
        } else if (sizeCategory === 1) {
          return {
            q0: questions.q0
          }
          // If category is n, show questions 2 -> n
        } else if (sizeCategory > 1) {
          let result = {}
          for (let i = 1; i <= sizeCategory; i++) {
            result['q' + i] = questions['q' + i]
          }
          return result
        }
      }
    },
    questionsAnswered () {
      let count = 0
      for (let key in this.questions) {
        if (this.answers[key] !== 0) {
          count = count + 1
        }
      }
      return count
    },
    scores () {
      return this.$store.getters.scores[this.$route.params.id]
    },
    step1iscompleted () {
      if (this.chance !== null && this.impact !== null) {
        return true
      } else {
        return false
      }
    },
    step2iscompleted () {
      if (this.questionsAnswered === Object.keys(this.questions).length) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    goToStep (step) {
      this.step = step
      if (step === 3) {
        this.$store.commit('updateTopicCompleteness', {
          topic: this.$route.params.id,
          value: true
        })
        this.$store.commit('updateProgress', 'TRENDS_STARTED')
        this.$store.dispatch('updateDatabaseRecord')
      }
    },
    goToOverviewAndSave () {
      this.$router.push('/trends')
      this.$store.commit('updateProgress', 'TRENDS_STARTED')
      this.$store.dispatch('updateDatabaseRecord')
    },
    updateAnswer (questionKey, value) {
      this.$store.commit('updateAnswer', {
        topic: this.$route.params.id,
        questionKey,
        value
      })
    },
    checkForResult () {
      if (this.scores.topicHasResults !== true) {
        this.$store.commit('resetTopicAnswers', this.$route.params.id)
      }
    }
  },
  mounted () {
    if (
      this.$store.state.answers[this.$route.params.id].topicIsComplete === true
    ) {
      this.step = 3
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-image {
  display: block;
  max-width: calc(50% - 1.6rem);
}

.c-image--right {
  float: right;
  margin-bottom: 1.6rem;
  margin-left: 3.2rem;
}

.c-details-introduction {
  border-bottom: 1px solid rgba(#fff, 0.2);
  margin-bottom: 3.2rem;
  padding-bottom: 1.6rem;
}

.c-details-advice {
  margin-bottom: 2.4rem;
}
</style>
